const initialState=false;
const openCloseReducer=(state=initialState,action)=>{
        switch(action.type){
            case "OPEN": return false;
            case "CLOSE": return true;
            default: return false;
        }
} 

export default openCloseReducer;